var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOptions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 4,
    viewBox: "0 0 18 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.58002 3.78C2.40844 3.78 3.08002 3.10843 3.08002 2.28C3.08002 1.45157 2.40844 0.779999 1.58002 0.779999C0.75159 0.779999 0.0800171 1.45157 0.0800171 2.28C0.0800171 3.10843 0.75159 3.78 1.58002 3.78ZM8.58002 3.78C9.40844 3.78 10.08 3.10843 10.08 2.28C10.08 1.45157 9.40844 0.779999 8.58002 0.779999C7.75159 0.779999 7.08002 1.45157 7.08002 2.28C7.08002 3.10843 7.75159 3.78 8.58002 3.78ZM17.08 2.28C17.08 3.10843 16.4084 3.78 15.58 3.78C14.7516 3.78 14.08 3.10843 14.08 2.28C14.08 1.45157 14.7516 0.779999 15.58 0.779999C16.4084 0.779999 17.08 1.45157 17.08 2.28Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/options.e0f11f8c.svg";
export { ForwardRef as ReactComponent };